import type { JSX } from 'react'
import type { IInputProps } from 'atoms/Input'
import type { IInputBlockProps } from '../InputBlock'

import { InputCorners, InputPaddings } from 'atoms/Input'
import { ProfileInput } from 'atoms/Input/Templates'
import { TextBoxTypes } from 'atoms/TextBox'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { InputBlock } from '../InputBlock'
import { InputBlockMargins, InputBlockRowGaps } from '../InputBlock.h'

export interface IProfileInputBlockProps extends Omit<
  IInputBlockProps,
  'children'
> {
  type?: IInputProps['type']
  value?: IInputProps['value']
  min?: IInputProps['min']
  max?: IInputProps['max']
  pattern?: IInputProps['pattern']
  required?: IInputProps['required']
  maxLength?: IInputProps['maxLength']
  disabled?: IInputProps['disabled']
  defaultValue?: IInputProps['defaultValue']
  errorMessage?: IInputBlockProps['errorMessage']
  font?: IInputProps['font']
  placeholder?: IInputProps['placeholder']
  label?: IInputProps['label']
  onChange?: IInputProps['onChange']
  labelFont?: IInputProps['labelFont']
  paddings?: IInputProps['paddings']
  autoComplete?: string
  corners?: IInputProps['corners']
  labelColorDefault?: IInputProps['labelColorDefault']
}

export const ProfileInputBlock = ({
  type = 'text',
  value,
  min,
  max,
  pattern,
  required = true,
  maxLength,
  disabled,
  errorMessage = '',
  rowGap = InputBlockRowGaps.SIZE_10,
  font = TextBoxTypes.FontSm,
  labelFont = TextBoxTypes.FontLgBold,
  paddings = InputPaddings.SIZE_10,
  placeholder = '',
  label = '',
  width = 100,
  margins = InputBlockMargins.SIZE_10,
  autoComplete,
  onChange,
  corners = InputCorners.CORNERS_0,
  labelColorDefault = Colors.TEXT_ICON_PRIMARY,
  ...rest
}: IProfileInputBlockProps): JSX.Element => (
  <InputBlock
    rowGap={rowGap}
    errorMessage={errorMessage}
    width={width}
    margins={margins}
    {...rest}
  >
    <ProfileInput
      labelFont={labelFont}
      paddings={paddings}
      corners={corners}
      labelColorDefault={labelColorDefault}
      type={type}
      value={value}
      min={min}
      max={max}
      pattern={pattern}
      required={required}
      maxLength={maxLength}
      disabled={disabled}
      invalid={!!errorMessage}
      font={font}
      placeholder={placeholder}
      label={label}
      autoComplete={autoComplete}
      onChange={onChange}
    />
  </InputBlock>
)
